/**
 * "Are we the desktop app?" — and nothing else.
 *
 * Split out of `utils/tauri.js` on 17.09.2026. That file also carries the app's
 * generic Tauri helpers, among them `sendHttpRequest`: an arbitrary-HTTP
 * primitive. `records/itemLocation.js` needs only this predicate, and it is
 * inside the MCP import graph — so while the predicate lived there, asking
 * "desktop or web?" put `send_http_request`, `read_file_chunk`,
 * `register_upload_path` and `delete_temp_file` one import away from every MCP
 * handler (the shape review R-3 named on 2026-09-09).
 *
 * `utils/tauri.js` re-exports this, so nothing else has to change. A module in
 * the MCP graph imports it from HERE. Keep this file free of `invoke` —
 * `mcpAttackSurface.test.js` walks the graph and will say so.
 */
import { isTauri as coreIsTauri } from '@tauri-apps/api/core';

/**
 * Check if the app is running in Tauri (desktop webview).
 * Uses official API first — reliable with devUrl localhost + withGlobalTauri: false.
 */
export const isTauri = () => {
  if (typeof window === 'undefined') return false;
  try {
    if (coreIsTauri()) return true;
  } catch {
    // ignore
  }
  return (
    window.__TAURI__ !== undefined ||
    window.__TAURI_INTERNALS__ !== undefined ||
    window.location.protocol === 'tauri:' ||
    (typeof navigator !== 'undefined' && navigator.userAgent.includes('Tauri'))
  );
};
